module.exports = __webpack_public_path__ + "images/avatars/female/2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/2.svg
// module id = vlSI
// module chunks = 51